import { normalizeUnitsFromApi } from './defectSheetUnits.js'

export function taskStatusRequest (cached, { unitIndex, lineIndex, done }) {
  const sheet = cached?.data?.sheet
  const unit = normalizeUnitsFromApi(sheet?.items)[unitIndex]
  const line = unit?.lines?.[lineIndex]
  if (!sheet?.id || !unit?.unit_id || !line?.line_id || !sheet.revision) {
    throw new Error('Reload this defect sheet before changing task status.')
  }
  return {
    sheetId: sheet.id,
    payload: { unit_id: unit.unit_id, line_id: line.line_id, done, revision: sheet.revision },
    previousDone: !!line.done,
  }
}

export function applyTaskStatus (cached, task, metadata = {}) {
  if (!cached?.data?.sheet) return cached
  const sheet = cached.data.sheet
  if (metadata.id != null && String(metadata.id) !== String(sheet.id)) return cached
  if (metadata.revision != null && Number(sheet.revision) > Number(metadata.revision)) return cached
  const items = normalizeUnitsFromApi(sheet.items).map(unit => (
    unit.unit_id !== task.unit_id ? unit : {
      ...unit,
      lines: unit.lines.map(line => line.line_id === task.line_id ? { ...line, done: task.done } : line),
    }
  ))
  return { ...cached, data: { ...cached.data, sheet: { ...sheet, ...metadata, items } } }
}

export function applyTaskStatusEvent (cached, event) {
  const sheet = cached?.data?.sheet
  const revision = Number(event.sheet_revision)
  if (!sheet || !event.task_status || !Number.isInteger(revision) || revision < 1) return null
  if (revision <= Number(sheet.revision)) return cached
  if (revision !== Number(sheet.revision) + 1) return null
  const units = normalizeUnitsFromApi(sheet.items)
  if (!units.some(unit => unit.unit_id === event.task_status.unit_id && unit.lines.some(line => line.line_id === event.task_status.line_id))) return null
  return applyTaskStatus(cached, event.task_status, {
    id: event.sheet_id, revision, status: event.sheet_status, updated_at: event.updated_at,
  })
}
